import goCatPreferential from './goCatPreferential';
import home from './home';
import signUp from './signUp';
import newsAndInformation from './newsAndInformation';
export default {
    goCatPreferential,
    home,
    newsAndInformation,
    signUp
}